import React from 'react';
import ModernDashboard from '../../components/ModernDashboard';
import './Dashboard.css';

const DashboardPage: React.FC = () => {
  return <ModernDashboard />;
};

export default DashboardPage;
